"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledgeProject.form.title.edit': 'Modifica progetto',
    'knowledgeProject.form.title.add': 'Aggiungi progetto',
    'knowledgeProject.form.back': 'Indietro',
    'knowledgeProject.form.color.placeholder': '#007bff',
    'knowledgeProject.form.icon.placeholder': 'fas fa-folder',
};
